import { render, staticRenderFns } from "./jiceng.vue?vue&type=template&id=64f9a9d0&scoped=true&"
import script from "./jiceng.vue?vue&type=script&lang=js&"
export * from "./jiceng.vue?vue&type=script&lang=js&"
import style0 from "./jiceng.vue?vue&type=style&index=0&id=64f9a9d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9a9d0",
  null
  
)

export default component.exports